import realAxios from "axios";
import baseUrl from "../../base_url";

const axios = realAxios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

// Request interceptor — attach JWT token
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — handle 401 (expired/invalid token)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid — clear storage and redirect to login
      localStorage.removeItem("adminToken");
      
      // Avoid redirect loops if we're already on the login page
      if (window.location.pathname !== "/" && window.location.pathname !== "/login") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
